import React, { useEffect, useState } from 'react';
import PropTypes, { element } from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import { useHistory } from "react-router";
import { getSiteMovementDevices } from '../../../data/FirebaseUtil';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Toolbar from './Toolbar';
import styled from 'styled-components';
import moment from 'moment';
import { convertUtcToTimeZone } from '../../../data/dateTimeUtil';

import { DEVICE_STATES, DEVICE_MOMENT_CATEGORIES, DEFAULT_TIMESTAMP_TZ } from '../../../data/constants'
import './index.css'

const Heading = styled.div`
display:flex;
flex-direction:row;
align-items:center;
`;

const HeadingWithDate = styled.div`
display:flex;
flex-direction: column;
padding-left:10px;
margin-top:10px
`;

const Bold = styled.div`
font-weight:bold;
font-size:20px
`;

const StyledDate = styled.div`
color:gray;
font-size:15px;
`;

const MOVED_OUT_HEADERS = [

  { id: 'eventReportedAt', numeric: true, label: 'Moved Out' },
  { id: 'modelNumber', numeric: false, label: 'Model' },
  { id: 'serialNumber', numeric: false, label: 'Serial Number' },
  { id: 'previousSiteName', numeric: false, label: 'Last Site' },
  { id: 'lastSeenInPrevSite', numeric: false, label: 'Last Seen' },
  { id: 'deviceState', numeric: false, label: 'Status' },
  { id: 'userId', numeric: true, label: 'Checked Out By' },
  { id: 'apLocation', numeric: true, label: 'AP Location' },
  { id: 'batteryLevel', numeric: true, label: 'Battery %' },
  { id: 'siteName', numeric: true, label: 'Current Site' },
  { id: 'firstSeenInCurrSite', numeric: true, label: 'First Seen' },
  { id: 'deviceState', numeric: true, label: 'Status' },
  { id: 'userId', numeric: true, label: 'Current User' },

];
const MOVED_IN_HEADERS = [

  { id: 'eventReportedAt', numeric: false, label: 'Moved In' },
  { id: 'modelNumber', numeric: false, label: 'Model' },
  { id: 'serialNumber', numeric: true, label: 'Serial Number' },
  { id: 'siteName', numeric: true, label: 'Current Site' },
  { id: 'firstSeenInCurrSite', numeric: true, label: 'First Seen' },
  { id: 'deviceState', numeric: true, label: 'Status' },
  { id: 'userId', numeric: true, label: 'Checked Out By' },
  { id: 'apLocation', numeric: true, label: 'AP Location' },
  { id: 'batteryLevel', numeric: true, label: 'Battery %' },
  { id: 'previousSiteName', numeric: true, label: 'Last Site' },
  { id: 'lastSeenInPrevSite', numeric: true, label: 'Last Seen' },
  { id: 'deviceState', numeric: true, label: 'Status' },
  { id: 'userId', numeric: true, label: 'Checked Out By' },
];



function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, headCells,category } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <HeaderSeperator category={category}/>
      <TableRow>

        {headCells.map((headCell,i) => (
          <TableCell
            key={headCell.id}
            align={'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
            { i===0?<p className='movement-table-padding'>{headCell.label}</p>:headCell.label }
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}


function HeaderSeperator({ category }) {
  console.log("category is", category)
  if (category === DEVICE_MOMENT_CATEGORIES.MOVED_IN) {
    return (<TableRow style={{padding:'10px'}}>
    <TableCell ></TableCell>
    <TableCell></TableCell>
    <TableCell></TableCell>
    <TableCell className='movement-header-site movement-left-border'></TableCell>
    <TableCell className='movement-header-site'></TableCell>
    <TableCell className='movement-header-site'>Current Sites</TableCell>
    <TableCell className='movement-header-site'></TableCell>
    <TableCell className='movement-header-site'></TableCell>
    <TableCell className='movement-header-site movement-left-border'></TableCell>
    <TableCell className='movement-header-site'></TableCell>
    <TableCell className='movement-header-site'>Last Site</TableCell>
    <TableCell className='movement-header-site'></TableCell>
    <TableCell className='movement-header-site'></TableCell>
    <TableCell className='movement-header-site movement-right-border'></TableCell>
    </TableRow>
  )
  }else{
    return (<TableRow>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell className='movement-header-site movement-left-border'></TableCell>
        <TableCell className='movement-header-site'></TableCell>
        <TableCell className='movement-header-site'>Last Site</TableCell>
        <TableCell className='movement-header-site'></TableCell>
        <TableCell className='movement-header-site'></TableCell>
        <TableCell className='movement-header-site movement-left-border'></TableCell>
        <TableCell className='movement-header-site'></TableCell>
        <TableCell className='movement-header-site'>Current Site</TableCell>
        <TableCell className='movement-header-site'></TableCell>
        <TableCell className='movement-header-site'></TableCell>
        <TableCell className='movement-header-site'></TableCell>
        <TableCell className='movement-header-site movement-right-border'></TableCell>
     
      </TableRow>)

  }


}

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const searchparam = props;

  return (
    <Toolbar
      history={searchparam.history}
      fromDate={moment(searchparam?.fromDate).format('YYYY-MM-DD')}
      toDate={moment(searchparam?.toDate).format('YYYY-MM-DD')}
      siteName={searchparam?.siteName}
      category={searchparam?.category}
      subCategory={searchparam?.subCategory}
      deviceStateUpdatedBy={searchparam?.deviceStateUpdatedBy}
    />
  );
};



const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    width: '100%'
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

const getInputParams = (history) => {
  return {
    category: history?.location?.state?.category,
    siteName: history?.location?.state?.siteName,
    fromDate: history?.location?.state?.fromDate,
    toDate: history?.location?.state?.toDate
  }
}


export default function EnhancedTable() {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [rows, setRows] = React.useState([])
  const history = useHistory();
  const inputParams = getInputParams(history);
  const [totalCount, setTotalCount] = useState(10);
  const [isLoading, setIsLoading] = useState(false);

  let headCells = inputParams.category === DEVICE_MOMENT_CATEGORIES.MOVED_IN ? MOVED_IN_HEADERS : MOVED_OUT_HEADERS;
  console.log('inputParams.category ',inputParams.category)
  headCells = headCells.map(element=>{
    return {
      ...element,
      minWidth:170
    }
  })

  useEffect(() => {
    getDevices({ pageNumber: page, pageSize: rowsPerPage })
  }, [])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    let sortOrder = isAsc ? 'desc' : 'asc'
    setOrder(sortOrder);
    setOrderBy(property);
    getDevices({ pageNumber: page, pageSize: rowsPerPage, sortingOrder: sortOrder, orderBy: property })
  };





  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getDevices({ pageNumber: newPage, pageSize: rowsPerPage })

  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getDevices({ pageNumber: 0, pageSize: parseInt(event.target.value, 10) })
  };



  const getDevices = async ({ pageNumber, pageSize, sortingOrder, orderBy }) => {
    try {
      let input = {
        "siteName": inputParams.siteName,
        "movementType": inputParams.category,
        "category": "deviceSiteChanged",
        "startDate": moment(inputParams?.fromDate).format('YYYY-MM-DD'),
        "endDate": moment(inputParams?.toDate).format('YYYY-MM-DD'),
        "pageNumber": pageNumber,
        "pageSize": pageSize,
      }
      if (sortingOrder) {
        input["sortingOrder"] = sortingOrder;
      }
      if (orderBy) {
        input["orderByCol"] = orderBy;
      }
      setIsLoading(true)
      const result = await getSiteMovementDevices(input);
      if (result.data.rows.length === 0) {
        setIsLoading(false)
        return;
      }
      setTotalCount(result.data.rows[0].totalCount);
      setRows(result.data.rows);
      setIsLoading(false)

    } catch (err) {
      setIsLoading(false)
    }



  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper} style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1', position: 'relative' }}>
        {
          isLoading && <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
            <CircularProgress color="primary" />
          </div>
        }
        <Heading style={{ paddingLeft: 25, paddingTop: 20 }}>
          <div>
            <Button variant="contained" onClick={() => history?.location?.state?.backToEventCount ? history.go(-2) : history.goBack()} startIcon={<ArrowBackIcon />} />
          </div>
          <HeadingWithDate>
            <Bold>{inputParams.siteName}</Bold>
            <StyledDate>{moment(inputParams.fromDate).format('YYYY/MM/DD')} - {moment(inputParams.toDate).format('YYYY/MM/DD')}</StyledDate>
          </HeadingWithDate>
        </Heading>
        <EnhancedTableToolbar
          category={inputParams.category}
          fromDate={inputParams.fromDate}
          toDate={inputParams.toDate}
          siteName={inputParams.siteName}
          history={history}
        />

        <TableContainer >
          {/* <HeaderSeperator category={inputParams.category} /> */}
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={'large'}
            aria-label="enhanced table"
            sx={{ border: 1 }}
          >

            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              headCells={headCells}
              category = {inputParams.category}
            />

            <TableBody>
              {rows
                .map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow>
                      {headCells
                        .map((element, i) => {
                          if (element.id === 'deviceState') {
                            return <TableCell style={{ minWidth: element.minWidth }} key={"device" + i} align="left"><p className='movement-table-padding'>{DEVICE_STATES[row[element.id]]}</p></TableCell>
                          }
                          //TODO: timestamp to be converted to localtimezone based timestamp
                          if (element.id === 'lastSeenInPrevSite') {
                            return <TableCell style={{ minWidth: 250}}  key={"lastSeenInPrevSite" + i} align="left"><p className='movement-table-padding'>{convertUtcToTimeZone(row[element.id], row['timeZoneActual'])}</p></TableCell>
                          }
                          if (element.id === 'firstSeenInCurrSite') {
                            return <TableCell style={{ minWidth: 250 }} key={"firstSeenInCurrSite" + i} align="left"><p className='movement-table-padding'>{convertUtcToTimeZone(row[element.id], row['timeZoneActual'])}</p></TableCell>
                          }
                          if (element.id === 'eventReportedAt') {
                            return <TableCell style={{ minWidth: 250 }} key={"eventReportedAt" + i} align="left"><p className='movement-table-padding'>{ convertUtcToTimeZone(row[element.id], row['timeZoneActual'])}</p></TableCell>
                          }
                          return <TableCell style={{ minWidth: element.minWidth }} align="left">{row[element.id]}</TableCell>
                        }
                        )}
                    </TableRow>
                  );
                })}

            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

    </div>
  );
}
